import { Box, Grid2 as Grid, Paper } from "@mui/material";
import { ProcessDataNumberTextField } from "../form-fields/process-data/ProcessDataNumberTextField";
import { ProcessDataTextFieldDE } from "../form-fields/process-data/ProcessDataTextFieldDE";

export const TableForemanEtc = () => {
	return (
		<Box padding={1}>
			<Grid
				container
				spacing={1}
				direction={"column"}
				justifyContent="space-around"
			>
				<Grid>
					<ProcessDataNumberTextField field={"MWH"} />
				</Grid>
				<Grid>
					<ProcessDataNumberTextField
						field={"ElectrodeConsumption"}
						label={"Elec Consumption"}
					/>
				</Grid>
				<Grid>
					<ProcessDataNumberTextField
						field={"ArcStability"}
						label={"Arc Stability"}
					/>
				</Grid>
				<Grid>
					<ProcessDataNumberTextField
						field={"OxygenVolume"}
						label={"O2 Volume"}
						decimals={1}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};
